import type { DefinedAppAction } from 'actions/types/ActionTypes'
import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import wait from 'lib/promise/wait'
import { getCampaignTierStanding } from 'loyalty/tierUpgradeCampaign/emailDomainEligibility'
import type { ThunkAction } from 'redux-thunk'

// Delays before each reload; the first reload is immediate
const RETRY_DELAYS_MS = [0, 1500, 3000, 6000]

/**
 * Reloads the loyalty account after a tier upgrade claim until it shows the new tier. A forced
 * reload reuses a reload that's already in flight (which may have started before the upgrade), and
 * the tier can take a moment to update after the claim, so a single reload can return the old tier.
 * Showing the new tier also lets the global rewards notification celebrate it.
 */
function refreshLoyaltyAccountAfterTierClaim(
  campaignTiers: Array<App.LoyaltyTier>,
): ThunkAction<Promise<void>, App.State, undefined, DefinedAppAction> {
  return async(dispatch, getState) => {
    for (const delay of RETRY_DELAYS_MS) {
      if (delay) await wait(delay)
      await dispatch(fetchLoyaltyAccount(undefined, { force: true }))
      const tier = getState().loyalty.account.data?.tier
      if (tier && getCampaignTierStanding(tier, campaignTiers) !== 'upgradable') return
    }
  }
}

export default refreshLoyaltyAccountAfterTierClaim
